export default __webpack_public_path__ + "4b76f5405e54549d60833cca0b1450da.png";